import React, { createContext, useContext, useState } from 'react';

const GuidelinesContext = createContext();

export const useGuidelines = () => useContext(GuidelinesContext);

export const GuidelinesProvider = ({ children }) => {
  const [filteredGuidelines, setFilteredGuidelines] = useState('');
  const [clinicalGuideLines, setClinicalGuidelines]=useState('');

  return (
    <GuidelinesContext.Provider value={{ filteredGuidelines, setFilteredGuidelines,clinicalGuideLines,setClinicalGuidelines }}>
      {children}
    </GuidelinesContext.Provider>
  );
};
